export const PAYMENT_STATUS = {
    pendingPayment: 'Por pagar',
    Aprobada: 'Pagada',
    Rechazada: 'Rechazada',
    Expirada: 'Expirada',
    Cancelada: 'Cancelada'
};

export const USER_ROLES = {
    INMOBILIARIA: 'inmobiliaria',
    USER: 'user',
    COMPANY: 'company',
    ADMIN_PH: 'administradorPH',
    COMPANY_PARTNER: 'companyPatner',
    USER_ADMIN_UNIT: 'userAdminUnit',
    USER_PARTNER: 'userPatner'
}

export const PAYMENT_STATUS_VALUES = {
    paid: 'paid',
    pending: 'pending'
}

export const COMPANY_STATUS_VALUES = {
    pending: 'pendingPayment',
    approved: 'Aprobada'
}